import { errorTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/constants'

import { productDialogPlacements } from './constants'

export const getErrors = errors => {
  return {
    hasPlacementError: errors.some(e => e.type === errorTypes.actionMessagePlacementEmpty),
    hasProductConditionError: errors.some(e => e.type === errorTypes.actionProductConditionIncomplete),
  }
}

export const isProductDialogPlacement = placement => productDialogPlacements.includes(placement)
